"use strict";
// -------------------------------------------//
//              Timeline directive
// -------------------------------------------//

angular.module('app.directives.timeline', []).directive('timeline', [
    '$document', '$rootScope', '$timeout', '$filter', 'TimeEntry', 'xCenterConfig',
    function($document, $rootScope, $timeout, $filter, TimeEntry, xCenterConfig) {
        var obj = {
            x: 0,
            startX: 0,
            initValue: 0,
            scope: {
                // Timelinewidth
                timelinewidth: '=timelinewidth',
                withButtons: '=withButtons',
                condition: '=condition',
                editMode: '=sceneeditmode',
                //timeprogram : '=timeprogram',
                day: '=day',
                weekday: '=weekday',
                weekdaystring: '=weekdaystring'
            },
            restrict: 'AE',
            templateUrl: 'views/form/timeline.html',

            // -------------------------------------------//
            //              Link function
            // -------------------------------------------//
            link: function(scope, element, attrs, controller) {

                //var touchConfig = appConfig();
                //var touchStart = touchConfig.touchStart;
                //var touchMove = touchConfig.touchMove;
                //var touchEnd = touchConfig.touchEnd;
                // -------------------------------------------//
                //              Calculate Sec to PX
                // -------------------------------------------//
                function SecToPx(min) {
                    // 100% px is timelinewidth
                    var p = (min * 60) / (24 * 3600);

                    return p * scope.timelinewidth;
                }


                /* INIT */
                // var startX = offset(element),
                //     startY = 0,
                //     x = 0,
                //     y = 0;

                /* Prepare incoming Data */

                scope.rootScope = $rootScope;
                //var eloffset = offset(element).left;
                scope.offset = function() {
                    return offset(element).left;
                };
                var container = element.find('div').eq(0);
                // var saveclear = false;
                // var initValue = 0;
                // var objtype = 0;
                // var flags = 0;
                // var steps = 1;
                //scope.editMode = false;
                scope.entries = [];
                // Max space between two entries in min
                scope.minTimeEntryMin = SecToPx(xCenterConfig.timeprogram.minTimeEntryMin);
                //scope.minTimeEntryMin = SecToPx(conf_minTimeEntryMin);
                scope.minMinutesBetweenTimeEntrys = SecToPx(xCenterConfig.timeprogram.minMinutesBetweenTimeEntrys);
                scope.timelineStep = SecToPx(xCenterConfig.timeprogram.timelineStep);

                container.css({
                    position: 'relative',
                    'width': scope.timelinewidth + 'px',
                    'min-width': scope.timelinewidth + 'px'
                });
                /*
                 scope.$watch('condition.editMode',function(value,oldvalue){
                 scope.editMode = value;
                 })*/
                scope.$watch('condition.refresh', function(value, oldvalue) {
                    scope.init();
                });

                scope.$on('timeline_update', function() {
                    scope.init();
                });

                scope.$on('timeline_refresh' + scope.day.WeekDay, function(event, a) {

                    $timeout(function() {
                        scope.refreshEntrys(a.entries);

                    });
                });

                scope.$on('timeline_pushToTimeprogram', function(event, a) {
                    scope.pushToTimeProgram();
                });

                //scope.$on('timeline_cleanUpEntrys');

                scope.refreshEntrys = function(e) {
                    // e are the new entries coming from cl_timeentry on applytimelines
                    scope.entries = [];
                    // scope.timeprogram.WeekProgramEntries = [];

                    if (e && e.length) {
                        e.walk(function(o, i) {
                            let el;
                            if (o.apiObject != undefined) {
                                el = o.apiObject();
                            } else {
                                el = {
                                    "Enabled": true,
                                    "Start": o.Start.local(),
                                    "End": o.End.local(),
                                    "WeekDay": o.WeekDay,
                                    "AstroOffsetEnd": o.AstroOffsetEnd,
                                    "AstroOffsetStart": o.AstroOffsetStart,
                                    "AstroTypeEnd": o.AstroTypeEnd,
                                    "AstroTypeStart": o.AstroTypeStart,
                                    "ReferenceDay": o.ReferenceDay,
                                    "AstroIconStart": o.AstroIconStart,
                                    "AstroIconEnd": o.AstroIconEnd
                                };
                            }
                            el.WeekDay = scope.day.WeekDay;
                            //el.scope = scope;
                            var timeentry = new TimeEntry();
                            timeentry.initEntry(scope, element, el);
                            timeentry.$document = $document;
                            scope.entries.push(timeentry);
                        });
                    }
                    scope.pushToTimeProgram();

                    //scope.$digest();
                };

                var getGradientStyle = (wpe) => {
                    let gradArr = [];
                    /* Background calculated for css. */
                    /* This calculation is modal dialog in editing scene details. */
                    let percent = (wpe.width / 490) * 84;
                    if (percent > 84) {
                        percent = 84;
                    }
                    if (wpe.AstroTypeStart === 1) {
                        gradArr.push('linear-gradient(-135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, red 100%)');
                    } else if (wpe.AstroTypeStart === 2) {
                        gradArr.push('linear-gradient(-135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, blue 100%)');
                    }

                    if (wpe.AstroTypeEnd === 1) {
                        gradArr.push('linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, red 100%)');
                    } else if (wpe.AstroTypeEnd === 2) {
                        gradArr.push('linear-gradient(135deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0) ' + percent + '%, blue 100%)');
                    }

                    gradArr.push('linear-gradient(to right, rgba(168,203,48,1) 0%, rgba(168,203,48,1) 20%,rgba(168,203,48,1) 80%, rgba(168,203,48,1) 100%)');

                    return gradArr.join();
                };

                scope.init = function() {

                    if (scope.condition != undefined) {
                        //scope.timeprogram = [];
                        scope.timeprogram = scope.condition.ConditionData.TimeProgram;
                        //	scope.condition.TimeProgram.temp = [];
                        scope.filterEntries = $filter('filter')(scope.timeprogram.WeekProgramEntries, {
                            WeekDay: scope.weekday
                        });

                        /*if(scope.condition.editMode == true)
                         {
                         scope.editMode == true;
                         }else{
                         scope.editMode == false;
                         }*/

                        if (scope.filterEntries) {
                            scope.entries = [];
                            for (var i = 0; i < scope.filterEntries.length; i++) {

                                var timeentry = new TimeEntry();
                                timeentry.initEntry(scope, element, scope.filterEntries[i]);
                                timeentry.$document = $document;

                                const wpe = timeentry;
                                timeentry.background = getGradientStyle(wpe);

                                scope.entries.push(timeentry);
                            }
                        }
                        //scope.condition.TimeProgram.temp[scope.weekday] = scope.entries;
                    }


                };

                scope.init();

                scope.pushToTimeProgram = function() {
                    for (let i = scope.timeprogram.WeekProgramEntries.length - 1; i >= 0; i--) {
                        if (scope.timeprogram.WeekProgramEntries[i].WeekDay == scope.weekday) {
                            scope.timeprogram.WeekProgramEntries.splice(i, 1);
                        }
                    }
                    for (let i = 0; i < scope.entries.length; i++) {
                        if (!scope.entries[i].background) {
                            scope.entries[i].background = getGradientStyle(scope.entries[i]);
                        }
                        ['Start', 'End'].forEach(dateVar => {
                            if (!scope.entries[i]['AstroIcon' + dateVar]) {
                                scope.entries[i]['AstroIcon' + dateVar] = 'icon-zeitprogramm';
                            }
                        });

                        scope.timeprogram.WeekProgramEntries.push(
                            scope.entries[i].apiObject()
                        );
                    }


                };

                // -------------------------------------------//
                //              Cleanup all entrys. Merge, cut
                // -------------------------------------------//

                scope.cleanUpEntrys = function(options) {

                    //scope.entries = $filter('filter')(scope.timeprogram.WeekProgramEntries ,{ WeekDay: scope.weekday});
                    for (var i = scope.entries.length - 1; i >= 0; i--) {
                        var a = scope.entries[i];
                        //var diff = (a.pointTwoX - a.pointOneX);
                        if (
                            (a.pointTwoX >= a.pointOneX && (a.pointTwoX - a.pointOneX) < scope.minTimeEntryMin)
                            || (a.pointTwoX < a.pointOneX && (a.pointOneX - a.pointTwoX) < scope.minTimeEntryMin)
                        ) {
                            scope.entries.splice(i, 1);
                        }
                        if (scope.entries.length > 1) {
                            for (var j = scope.entries.length - 1; j >= 0; j--) {
                                if ((i !== j) && scope.entries[i] != undefined && scope.entries[j] != undefined) {
                                    // Union

                                    var b = scope.entries[j];
                                    var aOne = Math.round(a.pointOneX);
                                    var aTwo = Math.round(a.pointTwoX);
                                    var bOne = Math.round(b.pointOneX);
                                    var bTwo = Math.round(b.pointTwoX);
                                    if (aOne < bOne && aTwo > bTwo) {
                                        // a is inside of b so we can remove a
                                        scope.entries.splice(j, 1);

                                    } else if (

                                        (aOne <= bOne && aTwo >= bOne && aTwo <= bTwo)
                                    ) {
                                        // a pointOne is smaller
                                        // a pointTwo is greater than b.pointOne and smaller than b.pointTwo
                                        // Union them
                                        a.width = (b.pointTwoX - a.pointOneX);
                                        a.left = a.pointOneX;
                                        a.pointOneX = a.pointOneX;
                                        a.pointTwoX = b.pointTwoX;

                                        a.end = a.pxToSec(a.pointTwoX);
                                        a.start = a.pxToSec(a.pointOneX);
                                        scope.entries.splice(j, 1);
                                    } else if (
                                        (aOne >= bOne && aOne <= bTwo && aTwo >= bTwo)
                                    ) {
                                        // union them. splice

                                        a.width = (a.pointTwoX - b.pointOneX);
                                        a.left = b.pointOneX;
                                        a.pointOneX = b.pointOneX;
                                        a.pointTwoX = a.pointTwoX;
                                        a.end = a.pxToSec(a.pointTwoX);
                                        a.start = a.pxToSec(a.pointOneX);
                                        scope.entries.splice(j, 1);

                                    } else if (
                                        (aTwo >= (bOne - scope.minMinutesBetweenTimeEntrys) && aOne <= bOne)
                                    ) {

                                        a.width = (b.pointTwoX - a.pointOneX);
                                        a.left = a.pointOneX;
                                        //a.pointOneX = a.pointOneX;
                                        a.pointTwoX = b.pointTwoX;

                                        a.end = a.pxToSec(a.pointTwoX);
                                        a.start = a.pxToSec(a.pointOneX);
                                        scope.entries.splice(j, 1);

                                    }

                                }
                            }

                        }
                    }
                    scope.entries = $filter('orderBy')(scope.entries, 'WeekDay');
                    if (options && options.fn != undefined) {
                        options.fn();
                    }


                };


                // -------------------------------------------//
                //              Mousedown handler
                // -------------------------------------------//
                container.on('mousedown', function(event) {
                    event.touches = [{
                        clientX: event.clientX,
                        clientY: event.clientY
                    }];
                    if (!scope.editMode) {
                        return;
                    }
                    scope.addEntry(event.touches[0].clientX, event);
                });

                container.on('touchstart', function(event) {
                    if (!scope.editMode) {
                        return;
                    }
                    scope.addEntry(event.touches[0].clientX, event);
                });

                scope.initEntry = function(left) {
                    var nl = left - scope.offset();
                    var timeentry = new TimeEntry();

                    timeentry.$document = $document;

                    timeentry.scope = scope;
                    timeentry.initEntry(scope, element, timeentry);

                    var quarterPx = timeentry.SecToPx((60 * 15));
                    var max = timeentry.SecToPx(60 * 60 * 24) - timeentry.SecToPx(xCenterConfig.timeprogram.createTimeEntryMin * 60);

                    if (nl > max) {
                        nl = max;
                    }
                    nl = (Math.floor(nl / quarterPx) * quarterPx);

                    timeentry.setpointOneX(nl);
                    // xCenterConfig.timeprogram.minTimeEntryMin
                    // Manual
                    var pointTwo = Math.floor((nl + timeentry.SecToPx(xCenterConfig.timeprogram.createTimeEntryMin * 60)) / quarterPx) * quarterPx;
                    if (pointTwo >= timeentry.SecToPx(60 * 60 * 24)) {
                        pointTwo = timeentry.SecToPx(60 * 60 * 24);
                    }
                    timeentry.setpointTwoX(pointTwo);



                    timeentry.start = timeentry.pxToSec(nl);
                    timeentry.end = timeentry.pxToSec((timeentry.left + timeentry.width));
                    return timeentry;
                };

                scope.addEntry = function(left, event) {
                    if (scope.condition.$UI == undefined) {
                        scope.condition.$UI = {};
                    }

                    //if (scope.condition.$UI.copyDays != undefined) {}
                    if (
                        (scope.condition.$UI.copyMode == undefined || scope.condition.$UI.copyMode == false) ||
                            (scope.condition.$UI.copyMode == true && scope.condition.$UI.copyDays != undefined && scope.condition.$UI.copyDays.hasOwnProperty(scope.day.Tag)
                            )
                    ) {

                        if (scope.condition.$UI.copyMode == true && scope.condition.$UI.copyMaster.Tag == !scope.day.Tag) {
                            scope.condition.$UI.copyMaster = scope.day;
                        }

                        var timeentry = scope.initEntry(left);
                        scope.entries.push(timeentry);
                        timeentry.startDrag(event, timeentry);
                        scope.$apply();
                    }
                };


                // -------------------------------------------//
                //             Get Offset => extract to one function
                // -------------------------------------------//
                function offset(elm) {
                    try {
                        return elm.offset();
                    } catch (e) {}
                    var rawDom = elm[0];
                    var _x = 0;
                    var _y = 0;
                    var body = document.documentElement || document.body;
                    var scrollX = window.pageXOffset || body.scrollLeft;
                    var scrollY = window.pageYOffset || body.scrollTop;
                    _x = rawDom.getBoundingClientRect().left + scrollX;
                    _y = rawDom.getBoundingClientRect().top + scrollY;
                    return {
                        left: _x,
                        top: _y
                    };
                }


            }

        };
        return obj;


    }
]);
